const Itemapi = [
    {
        id :0,
        name : "HeadPhone",
        img : "./img/Headphone.jpg",
        price : 2.5,
        qty : 1,
        categary : "Headphone",
        desc : "Sometimes referred to as earphones, headphones are a hardware output device that plug into a computer line out or speakers port. Headphones allow you to listen to audio or watch a movie without disturbing people around you."
    },
    {
        id :1,
        name : "Laptop",
        img : "./img/laptop.jpg",
        price : 4.0,
        qty : 1,
        categary : "leptop",
        desc : "A laptop computer, sometimes called a notebook computer by manufacturers, is a battery- or AC-powered personal computer generally smaller than a briefcase that can easily be transported and conveniently used in temporary spaces such as on airplanes, in libraries, temporary offices, and at meetings."
    },
    {
        id :2,
        name : "Selling Fan",
        img : "./img/fanImg.jpg",
        price : 5.7,
        qty : 1,
        categary : "electronic",
        desc : "Electronic device means an item that operates by controlling the flow of electrons or other electrically charged particles in circuits, using interconnections such as resistors, inductors, capacitors, diodes, switches, transistors, or integrated circuits"
    },
    {
        id :3,
        name : "Mobile",
        img : "./img/mobile.jpg",
        price : 3.4,
        qty : 1,
        categary : "mobile",
        desc : "A mobile phone, cellular phone, cell phone, cellphone, handphone, hand phone or pocket phone, sometimes shortened to simply mobile, cell, or just phone, is a portable telephone that can make and receive calls over a radio frequency link while the user is moving within a telephone service area."
    },
    {
        id: 4,
        name : "Car",
        img : "./img/car.jpg",
        price :9.5,
        qty:1,
        categary : "car",
        desc :"Buy Now a Premium Range of Car Body Cover to Give the Best Protection at Discounted Price. AutoFurnish is the One Stop Shop for All Your Car Needs. Shop Now to Avail Best Offers! Luxury Cars. Premium quality available. COD Available. Customized Products."
    },
    {
        id : 5,
        name : "Bulb",
        img : "./img/bulb.jpg",
        price :  4.1,
        qty:1,
        categary : "electronic",
        desc : "one in which a filament gives off light when heated to incandescence by an electric current. — called also incandescent, incandescent lamp. b : fluorescent lamp."
    },
    {
        id : 6,
        name : "Smart Watch",
        img : "./img/watch.jpg",
        price : 33.5,
        qty : 1,
        categary : "watch",
        desc: "A smartwatch is a wearable computing device that closely resembles a wristwatch or other time-keeping device. In addition to telling time, many smartwatches are Bluetooth-capable. The watch becomes a wireless Bluetooth adaptor capable of extending the capabilities of the wearer's smartphone to the watch."
        
    },
    {
        id : 7,
        name : "Smart Band",
        img : "./img/band.jpg",
        price : 7.4,
        qty : 1,
        categary : "fashion",
        desc : "smart band (plural smart bands) A mobile device worn on the wrist, often with a display that can be used to control a smartphone or to keep track of information such as fitness levels."
    },
    {
        id : 8,
        name : "Smart Band",
        img : "./img/watch1.jpg",
        price :  5.6,
        qty : 1,
        categary : "watch",
        desc : "smart band (plural smart bands) A mobile device worn on the wrist, often with a display that can be used to control a smartphone or to keep track of information such as fitness levels."
    },
    {
        id : 9,
        name : "Leptop Bag",
        img : "./img/bag.jpg",
        price : 6.0,
        qty : 1,
        categary : "leptop",
        desc : "A laptop sleeve, also sometimes called a laptop pouch or bag, is typically a sleeve/bag/pouch manufactured from a material such as neoprene or leather, that is slightly larger than the laptop, and designed to protect the device from bumps, scratches, water and dust in everyday use."
    },

];
export default Itemapi;